// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__RopUT","rowLink":"styles_rowLink__-e-7M","actions":"styles_actions__dotSF","pencil":"styles_pencil__1JZmu","profiles":"styles_profiles__tg01U"};